<template>
    <div class="flex flex-col items-start justify-end gap-2 border-b border-gray-200 h-[80px]">
        <label :for="id" class="font-extralight ">
            {{ label }}
            <span v-if="required" class="text-red-500">*</span>
        </label>
        <select :id="id" :value="modelValue" @input="updateValue" class="ml-[-10px] w-full rounded-md bg-white pt-2 text-sm font-semibold text-gray-900  cursor-pointer">
            <option v-for="option in options" :key="option.key" :value="option.key">{{ option.value }}</option>
        </select>
    </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
    label: {
        type: String,
        required: true
    },
    modelValue: {
        required: true
    },
    options: {
        type: Array,
        required: true
    },
    required: {
        type: Boolean,
        default: false
    }
});

const id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

const emit = defineEmits(['update:modelValue']);

function updateValue(event) {
    emit('update:modelValue', event.target.value);
}
</script>
